import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const azugaConfig: TSPConfig = {
  key: 'azuga',
  name: 'Azuga',
  category: TSPCategory.CUSTOM,
  helpText: 'Input the credentials you use to log into the Azuga Web App.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
        ]}
      />
    );
  },
};

export default azugaConfig;
